













import { library } from '@fortawesome/fontawesome-svg-core';
import { faCode } from '@fortawesome/pro-light-svg-icons';
library.add(faCode);

import BaseTable from '../Common/Mixins/BaseTable.vue';
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Site, DataLoaderParams, Service } from '@/types';

@Component({ name: 'services-table' })
export default class ServicesTable extends Vue {
  title: string | null = 'Services';

  showCode: boolean = false;

  fields: object = {
    name: { label: 'Name' },
    slug: { label: 'Slug' },
    dns_name: { label: 'DNS Name' }
  };

  onRowClicked(service: Service): void {
    this.$router.push({ name: 'service', params: { serviceId: service.id } });
  }
}
